import { render, staticRenderFns } from "./dictDataDialog.vue?vue&type=template&id=78e85a70&scoped=true&"
import script from "./dictDataDialog.vue?vue&type=script&lang=js&"
export * from "./dictDataDialog.vue?vue&type=script&lang=js&"
import style0 from "./dictDataDialog.vue?vue&type=style&index=0&id=78e85a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e85a70",
  null
  
)

export default component.exports